import TimeSlot from './TimeSlot'

export default TimeSlot
